"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryOrderStatus = exports.LOYALTY_TRANSACTION_TYPES = exports.LOYALTY_ACTION_ID = exports.OrderStatus = void 0;
var OrderStatus;
(function (OrderStatus) {
    /** @deprecated not used anymore  */
    OrderStatus["DRAFT"] = "DRAFT";
    /** Received by distributor, but confirmation pending */
    OrderStatus["WAITING_TO_BE_CONFIRMED"] = "WAITING_TO_BE_CONFIRMED";
    /** Confirmed by distributor */
    OrderStatus["CONFIRMED"] = "CONFIRMED";
    /** Cancelled by distributor */
    OrderStatus["CANCELLED"] = "CANCELLED";
    /** @deprecated not used anymore  */
    OrderStatus["DELIVERY_PLANNED"] = "DELIVERY_PLANNED";
    /** @deprecated not used anymore  */
    OrderStatus["DELIVERY_ONGOING"] = "DELIVERY_ONGOING";
    /** @deprecated not used anymore  */
    OrderStatus["DELIVERED"] = "DELIVERED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
/* -------------------------------------------------------------------------- */
/*                                   LOYALTY                                  */
/* -------------------------------------------------------------------------- */
var LOYALTY_ACTION_ID;
(function (LOYALTY_ACTION_ID) {
    /** Incentive on Order value */
    LOYALTY_ACTION_ID["VALUE_INCENTIVE"] = "VALUE_INCENTIVE";
    /** Incentive on weekly Orders */
    LOYALTY_ACTION_ID["WEEKLY_INCENTIVE"] = "WEEKLY_INCENTIVE";
    /** Incentive after first X Orders made (given once per business_id) */
    LOYALTY_ACTION_ID["WELCOME_INCENTIVE"] = "WELCOME_INCENTIVE";
    /** Redeem points for a reward */
    LOYALTY_ACTION_ID["REDEEM_POINTS"] = "REDEEM_POINTS";
    // DO NOT USE - "REWARD" naming is for what the user buys with points (e.g petrol cards),
    // not the action granting points (what we now call "INCENTIVE")
    /** @deprecated*/
    LOYALTY_ACTION_ID["WELCOME"] = "WELCOME";
    /** @deprecated*/
    LOYALTY_ACTION_ID["VALUE"] = "VALUE";
    /** @deprecated*/
    LOYALTY_ACTION_ID["WEEKLY_REWARD"] = "WEEKLY_REWARD";
    /** @deprecated*/
    LOYALTY_ACTION_ID["REWARD_FIRST_X_TIMES_ORDERS"] = "REWARD_FIRST_X_TIMES_ORDERS";
    /** @deprecated*/
    LOYALTY_ACTION_ID["REPEAT_2_PER_MO"] = "REPEAT_2_PER_MO";
    /** @deprecated*/
    LOYALTY_ACTION_ID["REPEAT_1_PER_WK"] = "REPEAT_1_PER_WK";
})(LOYALTY_ACTION_ID || (exports.LOYALTY_ACTION_ID = LOYALTY_ACTION_ID = {}));
var LOYALTY_TRANSACTION_TYPES;
(function (LOYALTY_TRANSACTION_TYPES) {
    LOYALTY_TRANSACTION_TYPES["CREDIT"] = "CREDIT";
    LOYALTY_TRANSACTION_TYPES["DEBIT"] = "DEBIT";
})(LOYALTY_TRANSACTION_TYPES || (exports.LOYALTY_TRANSACTION_TYPES = LOYALTY_TRANSACTION_TYPES = {}));
var DeliveryOrderStatus;
(function (DeliveryOrderStatus) {
    DeliveryOrderStatus["TO_PREPARE"] = "TO_PREPARE";
    /**
     * @deprecated use TO_PREPARE instead
     */
    DeliveryOrderStatus["PENDING"] = "PENDING";
    DeliveryOrderStatus["TO_LOAD"] = "TO_LOAD";
    DeliveryOrderStatus["IN_TRANSIT"] = "IN_TRANSIT";
    DeliveryOrderStatus["DELIVERED"] = "DELIVERED";
    DeliveryOrderStatus["RETURNED"] = "RETURNED";
})(DeliveryOrderStatus || (exports.DeliveryOrderStatus = DeliveryOrderStatus = {}));
